import "./App.css"
import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

import Header from "./layout/Header"
import Footer from "./layout/Footer"
import MrBlob from "./components/MrBlob"
import AnimationRoutes from "./layout/AnimationRoutes"
import Menu from "./components/Menu"

import store from "./store/store"
import stockRecipes from "./mockedData/recipes"
import ToasterSignIn from "./components/ToasterSignIn"
import ToasterSignOut from "./components/ToasterSignOut"

function App() {
  const searchValue = store((state) => state.searchValue)
  const clearRecipes = store((state) => state.clearRecipes)
  const foundRecipes = store((state) => state.recipes)
  const setFoundRecipes = store((state) => state.setRecipes)
  const isUserLogged = store((state) => state.isUserLogged)

  const [tempRecipes, setTempRecipes] = useState([])
  const [isUserAuthorized, setIsUserAuthorized] = useState(isUserLogged)

  // search mechanism
  useEffect(() => {
    if (searchValue.length >= 2) {
      const filteredRecipes = stockRecipes.filter((recipe) => {
        if (recipe) {
          // Convert all values to lowercase for case-insensitive comparison
          const title = recipe.title.toLowerCase()
          const description = recipe.description.toLowerCase()
          const country = recipe.country.toLowerCase()
          const origin = recipe.origin.toLowerCase()

          // Check if any value in the recipe contains the search input
          return (
            title.includes(searchValue) ||
            description.includes(searchValue) ||
            country.includes(searchValue) ||
            origin.includes(searchValue) ||
            // search inside arrays
            recipe.ingredients.some((ingredient) =>
              ingredient.name.toLowerCase().includes(searchValue)
            ) ||
            recipe.instructions.some((instruction) =>
              instruction.toLowerCase().includes(searchValue)
            ) ||
            recipe.utensils.some((utensil) =>
              utensil.toLowerCase().includes(searchValue)
            )
          )
        } else {
          return false
        }
      })
      clearRecipes()
      setFoundRecipes(filteredRecipes)
    } else if (searchValue === "") {
      clearRecipes()
      setFoundRecipes(stockRecipes)
      setTempRecipes([])
    }
  }, [searchValue, setFoundRecipes, clearRecipes])


  useEffect(()=> {
    setIsUserAuthorized(isUserLogged)
  }, [isUserLogged])

  // colour selection based on location
  const pathName = useLocation().pathname
  const id = pathName.split("/")[2]
  let bgColour
  let titleColour

  // change colours
  if (pathName === "/" || pathName === "/search") {
    bgColour = "var(--clr_green_dark)"
    titleColour = "var(--clr_ocre"
  } else if (pathName === `/recipe/${id}`) {
    bgColour = "var(--clr_ocre)"
    titleColour = "var(--clr_green_dark"
  } else if (pathName === '/signin' || pathName === '/signup' || pathName === `/new-recipe/${id}` || pathName === `/account/${id}`) {
    bgColour = "var(--clr_green_dark)"
    titleColour = "var(--clr_ocre)"
  } else if (pathName === `/recipes-you-like/${id}`) {
    bgColour = "var(--clr_green_dark)"
    titleColour = "var(--clr_ocre"
  }

  // Conditional rendering for when there are no found recipes
  if (foundRecipes.length === 0 && searchValue.length >= 2) {
    return (
      <>
        <Menu />
        <Header bgColour={bgColour} titleColour={titleColour} />
        <div id='no_results'>
          <h1>No recipes found...</h1>
          <MrBlob />
        </div>
        <Footer bgColour={bgColour} titleColour={titleColour} />
      </>
    )
  } else {
    return (
        <>

          {isUserLogged? <ToasterSignIn /> : <ToasterSignOut/>}
          <Menu />
          <Header bgColour={bgColour} titleColour={titleColour} />
          <AnimationRoutes />
          <Footer bgColour={bgColour} titleColour={titleColour} />
        </> 
      )
  }
}

export default App